import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import { api } from "../api";
import { ArrowUpRight } from "lucide-react";

const Products = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.products().then(setItems).catch(() => setItems([]));
  }, []);

  return (
    <main className="bg-white">
      <SEO
        title="Ürünlerimiz"
        description="Koptur Grup A.Ş. prefabrik yapılar, konteynerler ve çelik yapı çözümleri."
        path="/urunlerimiz"
      />
      <PageHero
        kicker="Prefabrik & Çelik Yapı"
        title="Ürünlerimiz"
        subtitle="Prefabrik yapılar, konteynerler ve çelik konstrüksiyon çözümlerimizle projelerinize hızlı, ekonomik ve dayanıklı çözümler sunuyoruz."
      />

      <section className="pb-24">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          {items.length === 0 ? (
            <div className="text-neutral-500 text-center py-16">
              Henüz eklenmiş ürün yok. Admin panelinden ürün ekleyebilirsiniz.
            </div>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {items.map((p) => (
                <Link
                  key={p.id}
                  to={`/urun/${p.slug}`}
                  className="group rounded-2xl overflow-hidden border border-neutral-100 bg-white hover:shadow-[0_20px_40px_rgba(0,0,0,0.06)] transition-shadow duration-300 flex flex-col"
                >
                  <div className="aspect-[4/3] overflow-hidden bg-neutral-100">
                    {p.cover_image ? (
                      <img
                        src={p.cover_image}
                        alt={p.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                      />
                    ) : (
                      <div className="w-full h-full grid place-items-center text-neutral-400 text-sm">Görsel yok</div>
                    )}
                  </div>
                  <div className="p-5 flex-1 flex flex-col">
                    <div className="text-xs uppercase tracking-[0.2em] text-[#C9A24B] font-semibold">{p.category}</div>
                    <h3 className="mt-2 text-lg md:text-xl font-black text-[#1a1a1a] leading-tight group-hover:text-[#4E0D1C] transition-colors">
                      {p.title}
                    </h3>
                    {p.subtitle && <p className="mt-2 text-sm text-neutral-600 line-clamp-2">{p.subtitle}</p>}
                    <div className="mt-4 inline-flex items-center gap-2 self-start text-sm font-semibold text-[#4E0D1C]">
                      Detayı gör <ArrowUpRight className="w-4 h-4" />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default Products;
